module.exports = __webpack_public_path__ + "pr.svg?6949cd9f76c1e488de1074d5d04dc189";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/pr.svg
// module id = 1318
// module chunks = 0